
namespace Matrix.Exceptions {

    export class ExceptionInboxDialog extends SiteEntityDialog<ExceptionRow, any> {
        protected getFormKey() { return ExceptionInboxForm.formKey; }
        protected getIdProperty() { return ExceptionRow.idProperty; }
        protected getLocalTextPrefix() { return ExceptionRow.localTextPrefix; }
        protected getNameProperty() { return ExceptionRow.nameProperty; }
        protected getService() { return ExceptionService.baseUrl; }
        protected getDeletePermission() { return "NoPermission"; }
        protected getInsertPermission() { return "NoPermission"; }

        private popupMenuEl: JQuery;

        protected form = new ExceptionInboxForm(this.idPrefix);

        constructor() {
            super();

            this.form.UserTags.addValidationRule(this.uniqueName, (input) => {
                if (input.val()?.length > 100)
                    return "Please type no more than 100 characters!";
            });

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            //var availHeight = $(window).height() - 480;
            //this.form.Properties.getGridField().find('.json-viewer').css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            Workflow.replaceWithJsonViewer(this.form.Properties.element, this.entity.Properties);
        }

        protected updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('exception-links-button').toggle(
                !!(this.entity?.ExceptionLinks?.length ||
                    this.entity?.ExceptionSource == 'DataQualityTest'));

            this.form.AssignedTo.readOnly = this.isViewMode() ||
                !!this.entity?.ReviewedBy;

            this.cloneButton?.hide();
            this.deleteButton?.hide();
        }

        protected getLoadByIdRequest(id) {
            var request = super.getLoadByIdRequest(id);

            request.IncludeColumns = request.IncludeColumns || [];
            request.IncludeColumns.push(ExceptionRow.Fields.ExceptionLinks);

            return request;
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons.push({
                cssClass: 'exception-links-button',
                icon: 'fa-bars',
                title: 'Links',
                onClick: (e) => {
                    if (!this.popupMenuEl) {
                        this.popupMenuEl = $(`<ul style="width: 300px"></ul>`);
                        this.popupMenuEl.on('click', 'a', (e) => {
                            Exceptions.handleExceptionLinkClick(e);
                        });
                    }

                    var links = this.entity?.ExceptionLinks;

                    this.popupMenuEl.html('');

                    if (this.entity.ExceptionSource == 'DataQualityTest')
                        renderExceptionDialogLink(this.popupMenuEl, Data.TestResultDialog,
                            this.entity.ExceptionContext, "View Test Result");

                    links && Exceptions.renderExceptionLinks(this.popupMenuEl, links);
                    popupMenuShow(this.popupMenuEl, e);
                }
            });

            buttons.push({
                title: "Review",
                cssClass: 'review-button',
                icon: 'fa-thumbs-o-up',
                visible: () => Q.Authorization.username == this.entity.AssignedTo &&
                    !this.entity?.ReviewedBy,
                onClick: () => {
                    Q.confirm('Review this exception?', () => {
                        ExceptionService.Update({
                            EntityId: this.entityId,
                            Entity: {
                                ReviewedBy: Q.Authorization.username
                            }
                        },
                            response => {
                                Serenity.SubDialogHelper.triggerDataChange(this);
                                this.dialogClose();
                            });
                    });
                }
            });

            buttons.push({
                title: "Ignore",
                cssClass: 'ignore-button',
                icon: 'mdi mdi-volume-off',
                visible: () => !this.entity.ReviewedBy && !this.entity?.CompletedBy,
                onClick: () => {
                    const dialog = new ExceptionInboxIgnoringDialog();
                    dialog.element.on('dialogclose panelclose', () => {
                        Serenity.SubDialogHelper.triggerDataChange(this);
                        this.dialogClose();
                    });

                    dialog.execute({
                        EntityId: this.entityId,
                        IgnoredUntil: this.entity.IgnoredUntil
                    });
                }
            });

            buttons.push({
                title: "Complete",
                cssClass: 'complete-button',
                icon: 'fa-check-square-o',
                visible: () => Q.Authorization.username == this.entity.AssignedTo &&
                    !!this.entity?.ReviewedBy && !this.entity?.CompletedBy,
                onClick: () => {
                    Q.confirm('Complete this exception?', () => {
                        ExceptionService.Update({
                            EntityId: this.entityId,
                            Entity: {
                                CompletedBy: Q.Authorization.username
                            }
                        },
                            response => {
                                Serenity.SubDialogHelper.triggerDataChange(this);
                                this.dialogClose();
                            });
                    });
                }
            });
            return buttons;
        }
    }
}